import React from "react";

import logo from "../../../../images/logo.ico"; // for the logo in the header

import classes from "./Navigation.module.css";
import scollClasses from "../../../classes/ContainerClasses"

import { Link } from "react-router-dom";

//this component is for the navigation buttons
//the navigation links and the logo at the top of the landing section
const Navigation = () => {
  //functions to scroll to various sections
  const scrollToOurWork = () => {
    const element = document.getElementsByClassName(scollClasses.OurWorkContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToOurCenters = () => {
    const element = document.getElementsByClassName(scollClasses.MapContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToGiving = () => {
    const element = document.getElementsByClassName(scollClasses.GivingContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToFacts = () => {
    const element = document.getElementsByClassName(scollClasses.FactsNFIguresContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const scrollToCareers = () => {
    const element = document.getElementsByClassName(scollClasses.FooterContainer)[0];
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <Link to="/">
        <img
          src={logo}
          alt="logo"
          className={classes.logo + " " + classes.link}
        />
        </Link>
      </div>
      <div className={classes.right}>
        <div className={classes.link} onClick={scrollToOurWork}>Our Work</div>
        <div className={classes.link} onClick={scrollToOurCenters}>Our Centers</div>
        <div className={classes.link} onClick={scrollToGiving}>Giving</div>
        <div className={classes.link} onClick={scrollToFacts}>Facts & Figures</div>
        <div className={classes.link} onClick={scrollToCareers}>Careers</div>
      </div>
    </div>
  );
};
export default Navigation;
